import { getOrdersAndQuotesMatchingIdInsight } from '@ui/features/quote-builder/state/endpoints/get-orders-and-quotes-matching-id-insight';
import { MatchPending } from '@ui/features/quote-builder/types/match-pending';
import { MatchRejected } from '@ui/features/quote-builder/types/match-rejected';
import { ExtraReducerBuilder } from '@ui/features/quote-builder/types/shared';
import { QuoteBuilderPartInsightsStateType } from '@ui/features/quote-builder/types/state/part-insights';

import { MatchFulfilled } from '../../types/match-fulfilled';

function getOrdersAndQuotesMatchingIdInsightPending(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchPending<
    typeof getOrdersAndQuotesMatchingIdInsight.Types.QueryArg
  >,
) {
  const quoteLineUuid = action.meta.arg.originalArgs.query.snapQuoteLineUuid;

  if (!quoteLineUuid) {
    return;
  }

  if (state[quoteLineUuid]?.loadingMatchingIdInsight) {
    return;
  }

  if (!state[quoteLineUuid]) {
    state[quoteLineUuid] = {
      loadingMatchingIdInsight: true,
      loadingPartInsight: false,
      partInsights: null,
    };
    return;
  }

  state[quoteLineUuid].loadingMatchingIdInsight = true;
}

function getOrdersAndQuotesMatchingIdInsightFulfilled(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchFulfilled<
    typeof getOrdersAndQuotesMatchingIdInsight.Types.ResultType,
    typeof getOrdersAndQuotesMatchingIdInsight.Types.QueryArg
  >,
) {
  const { snapQuoteLineUuid, orderOrQuoteWithMatchingId } = action.payload;
  const partInsights = state[snapQuoteLineUuid]?.partInsights;

  if (!partInsights) {
    state[snapQuoteLineUuid] = {
      loadingMatchingIdInsight: false,
      loadingPartInsight: false,
      partInsights: null,
    };
    return;
  }

  state[snapQuoteLineUuid] = {
    loadingMatchingIdInsight: false,
    loadingPartInsight: state[snapQuoteLineUuid]?.loadingPartInsight ?? false,
    partInsights: {
      ...partInsights,
      crossSitePartId: {
        ...partInsights.crossSitePartId,
        orderOrQuoteWithMatchingId,
      },
    },
  };
}

function getOrdersAndQuotesMatchingIdInsightRejected(
  state: QuoteBuilderPartInsightsStateType,
  action: MatchRejected<
    typeof getOrdersAndQuotesMatchingIdInsight.Types.QueryArg
  >,
) {
  const quoteLineUuid = action.meta.arg.originalArgs.query.snapQuoteLineUuid;

  if (!quoteLineUuid) {
    return;
  }

  if (!state[quoteLineUuid]) {
    return;
  }

  state[quoteLineUuid].loadingMatchingIdInsight = false;
}

export function getOrdersAndQuotesMatchingIdInsightReducer(
  builder: ExtraReducerBuilder<QuoteBuilderPartInsightsStateType>,
) {
  builder.addMatcher(
    getOrdersAndQuotesMatchingIdInsight.matchPending,
    getOrdersAndQuotesMatchingIdInsightPending,
  );
  builder.addMatcher(
    getOrdersAndQuotesMatchingIdInsight.matchFulfilled,
    getOrdersAndQuotesMatchingIdInsightFulfilled,
  );
  builder.addMatcher(
    getOrdersAndQuotesMatchingIdInsight.matchRejected,
    getOrdersAndQuotesMatchingIdInsightRejected,
  );
}
